import type { ReactNode } from 'react';
import { cn } from '@shared/utils';
import { Spinner } from '../spinner';

interface ButtonProps {
  className?: string;
  color?: 'primary' | 'outlined';
  fullWidth?: boolean;
  type?: 'button' | 'submit' | 'reset';
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
  isLoading?: boolean;
  loadingPosition?: 'inside' | 'right';
  children?: ReactNode;
}

export const Button = (props: ButtonProps) => {
  const className = cn(
    'h-[40px] py-2 px-4 rounded-lg border border-transparent flex items-center justify-center cursor-pointer relative flex items-center justify-center gap-2 font-medium transition-all duration-200 max-md:h-[50px]',
    (!props.color || props.color === 'primary') && 'text-[#d7c29a] bg-[#272727] hover:bg-[#e5c496] hover:border-[#e5c496] hover:text-[#000]',
    props.color === 'outlined' && '!border-[#272727] bg-transparent text-[#000] hover:!border-[#e5c496] hover:bg-[#e5c496]',
    props.fullWidth && 'w-full',
    props.disabled && 'opacity-80',
    props.className,
  );

  return (
    <button className={className} type={props.type || 'button'} disabled={props.disabled || props.isLoading} onClick={props.onClick}>
      {props.children}
      {props.isLoading && (
        <div className={cn('relative', props.loadingPosition === 'right' && 'left-11.25 -ml-8.75')}>{props.isLoading && <Spinner />}</div>
      )}
    </button>
  );
};
